subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  const badge = document.querySelector(
    `[data-agriva-discount-badge][data-section-id="${data.sectionId}"]`
  );

  if (!badge) return;

  const { price, compare_at_price: compareAtPrice } = data.variant;
  const discountPercent =
    compareAtPrice && compareAtPrice > price
      ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice)
      : 0;

  badge.textContent = `−${discountPercent} %`;
  badge.setAttribute('aria-label', `${discountPercent}% rabatt`);
  badge.hidden = discountPercent === 0;
});
